import { evt } from "@javascripts/advertisements/constant";

export default class AdsVolumeStateService {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this._playerVolume = 1;
    this._isFadingAudio = false;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  playerVolume() {
    return this._playerVolume;
  }

  storePlayerCurrentVolume() {
    this._playerVolume = this.tech().volume();
  }

  init() {
    this.bindFadeOutAudio()
    this.bindFadeInAudio()
    this.bindAdStarted();
    this.bindAdEnd();
  }

  bindAdStarted() {
    this.tech().on('adstarted', () => {
      this.onAdStarted();
    });
  }

  bindFadeOutAudio() {
    this.tech().on(evt.FADE_OUT_AUDIO, () => {
      this._isFadingAudio = true
      this.storePlayerCurrentVolume()
    })
  }

  bindFadeInAudio() {
    this.tech().on(evt.FADE_IN_AUDIO, () => {
      this._isFadingAudio = false
    })
  }

  onAdStarted() {
    if(!this._isFadingAudio) {
      this.storePlayerCurrentVolume();
    }

    // return when muted so player can still be autoplayed
    // content player has 2 states, volume and mute.
    // ads player only have 1 state which is volume;
    // ads muted means the volume is 0
    // ads unmute means change the volume to 1
    if (this.tech().muted()) {
      return;
    }

    const adsVolumeGapSync = this.data().adsVolumeGapSync();
    const adsVolume = Math.round(Math.max(this.playerVolume() * 100 - adsVolumeGapSync, 10)) / 100;
    this.tech().plugin().imaObject().getAdsManager().setVolume(adsVolume);
  }

  bindAdEnd() {
    this.tech().on('adend', () => {
      if(this._isFadingAudio) return

      this.tech().volume(this.playerVolume());
    });
  }
}